const __WEBPACK_NAMESPACE_OBJECT__ = require("react-dnd-html5-backend");